"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFieldModel = getFieldModel;
exports.mergeProps = mergeProps;
exports.getParamList = getParamList;
exports.transferFieldType = transferFieldType;

var _data = require("../util/data");

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === "function";
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return "EagerThenable{" + {
            "-1": "pending",
            0: "resolved",
            1: "rejected"
          }[phase] + "}=" + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === "function" ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

/**
 * 返回指定code的model
 * @param model bill的model
 * @param code 指定字段的code
 * @param model
 * @param code
 * @returns {field}
 */
function getFieldModel(model, code) {
  var field = void 0;
  if (model && model.forms && model.forms.length > 0) {
    model.forms.some(function (form) {
      field = form && form.fields && form.fields.length > 0 && form.fields.find(function (field) {
        return field.code === code;
      });
      return field;
    });
  }
  return field;
}
/**
 * 从对象中拷贝指定的属性
 * @param obj 需要更改的对象
 * @param fromObj 参照对象
 * @param array 定义指定的属性
 */
function mergeProps(obj, fromObj, array) {
  if (_.isEmpty(fromObj)) {
    return;
  }
  if (array && array.length > 0) {
    array.forEach(function (prop) {
      fromObj[prop] && (obj[prop] = fromObj[prop]);
    });
  }
}

/**
 * 返回解析后的参数集合
 * @param paramList
 * @returns {Array}
 */
function getParamList(paramList) {
  var _paramList = [];
  if (paramList && paramList.length > 0) {
    paramList.forEach(function (v) {
      if (_.isObject(v)) {
        _paramList = _paramList.concat(Object.keys(v).map(function (key) {
          return { code: key, fromCode: v[key] };
        }));
      } else if (_.isString(v)) {
        _paramList.push({ code: v, fromCode: v });
      }
    });
  }
  return _paramList;
}

/**
 * 类型兼容
 * list 系列转换为 select 系列
 */
function transferFieldType(field) {
  if (_.isEmpty(field)) {
    return;
  }
  switch (field.type) {// 进行类型的兼容
    case "list":
      field.type = "select";
      break;
    case "multiList":
      field.type = "multiSelect";
      break;
    case "treeList":
      field.type = "treeSelect";
      break;
    case "treeMultiList":
      field.type = "treeMultiSelect";
      break;
  }
}